import { CornerNotificationCard } from 'design-system/src/components/CornerNotificationCard/CornerNotificationCard';
import { useDismissProductNotification } from '../../hooks/useGetProductNotification';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import { createTrackingProps } from 'shared-utils/analytics';

const FaxVerificationSuccessNotification = ({ productNotificationId }: { productNotificationId: string }) => {
  const { mutate: dismissNotification } = useDismissProductNotification();

  const content = (
    <Typography styledAs="bodyLargeDMSans" renderedAs="div">
      Your account is verified and ready to process prescriptions. You can always schedule trainings and update practice
      information in{' '}
      <Button
        to="/settings"
        textStyledAs="bodyLargeDMSans"
        variant="link"
        {...createTrackingProps({ elementName: 'Fax Verification Success Notification: Settings Link' })}
      >
        settings
      </Button>
      .
    </Typography>
  );

  return (
    <CornerNotificationCard
      variant="success"
      title="Your account is ready!"
      content={content}
      onDismiss={() => {
        dismissNotification(productNotificationId);
      }}
    />
  );
};

export default FaxVerificationSuccessNotification;
